// extracted by mini-css-extract-plugin
export var container = "projectList-module--container--RzgDk";
export var iconDefault = "projectList-module--iconDefault--ZFZGN";
export var iconLight = "projectList-module--iconLight--w6wvJ";
export var project = "projectList-module--project--Lp5OK";
export var projects = "projectList-module--projects--BEkCo";